import Typography, { TypographyVariant } from "./Typography";
import Separator from "./Separator";
import clsx from "clsx";

export type SectionTitleProps = {
    children?: JSX.Element;
    title: string;
    noSeperator?: boolean;
    variant?: TypographyVariant
};

const SectionTitle = ({
    children,
    title,
    noSeperator = false,
    variant = "headline-small"
}: SectionTitleProps) => {
    return (
        <>
            {noSeperator ? null : <Separator className="my-6" />}
            <div className={clsx("flex justify-between items-center mb-4", noSeperator && "my-6")}>
                <Typography variant={variant} component="h2">
                    {title}
                </Typography>
                {children}
            </div>
        </>
    );
};

export default SectionTitle;
